import {ApplicationLang, PersonGender, PersonType} from '@domain/common/common';
import {MemberDTO} from '@domain/member/member.dto';

export interface User {
  id: string;
  userName: string;
  firstName?: string;
  name?: string;
  email?: string;
  type?: PersonType;
  title?: PersonGender;
  lang?: ApplicationLang;
  state?: UserState;
  role?: UserRole;
  newsletter?: boolean;
  lastNewsletter?: string;
  canDelete?: boolean;
  memberships?: MemberDTO[];
  currentMembership?: MemberDTO | null;
}

export enum UserState {
  Registered = 'Registered',
  Active = 'Active'
}

export enum UserRole {
  Moderator = 'Moderator'
}

